import React, { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";

import { journalUpdate, addNutritionJournal, getNutrionJournalEntries } from "../../../store/actions";
import FillingGlass from "../../../sharedComponents/fillingGlass";
import { secondsToTime } from "../../../utils/common";

const Hydration = ({
	data,
	goal,
	journalUpdate,
	getNutritionJournalSummary,
	getNutrionJournalEntries,
	date,
	addNutritionJournal
}) => {
	const queryParam = `start_date=${moment(date).format("YYYY-MM-DD")}&end_date=${moment(date).format("YYYY-MM-DD")}`;
	const isIncrement = true;
	const hydrationData = [{ name: "hydration", value: 1 }, { name: "electrolyte", value: 1 }];

	const [change, setChange] = useState(false);
	const [enable, setEnable] = useState(true);
	const [editHydration, setEditHydration] = useState(false);
	const [editElectrolyte, setEditElectrolyte] = useState(false);

	const successHandler = (event) => {
		if (event.status >= 200 && event.status < 300) {
			setTimeout(() => {
				setChange(false);
			}, 500);
			getNutritionJournalSummary(queryParam);
			getNutrionJournalEntries(queryParam);
			setEditHydration(false);
			setEditElectrolyte(false);
			setEnable(true);
		}
	};

	const initJournalDay = (name, value) => {
		// Initiize Journal if not set for the day
		setEnable(false);
		const isHydration = name === "hydration" ? { hydration: value } : { electrolyte: value };

		const journalValues = {
			added_on: moment(date ? date : new Date()).format("YYYY-MM-DD") + " " + secondsToTime(moment()),
			entry: name === "hydration" ? "hydration" : "electrolyte",
			quantity: 1,
			...isHydration
		};
		addNutritionJournal(journalValues, successHandler);
	}

	const incrementHydrationValue = ({ value, name }, increment) => {
		if (data && data.id) {
			setEnable(true);
			const values = {};
			values.id = data.id;
			const hydrationValue = data[name] + (increment ? value : -value);
			values[name] = hydrationValue < 0 ? 0 : hydrationValue;
			setChange(true);
			journalUpdate(values, successHandler);
		} else {
			if (increment) {
				initJournalDay(name, value);
			}
		}
	};

	const updateValues = (name, value) => {
		if (data && data.id) {
			setEnable(true);
			const values = {};
			values.id = data.id;
			values[name] = value < 0 ? 0 : value;
			setChange(true);
			journalUpdate(values, successHandler);
		} else {
			const init_value = value < 0 ? 0 : value
			initJournalDay(name, init_value);
		}

	}

	const editOptions = (name) => {
		let show = false
		let set;
		if (name === 'hydration') {
			show = editHydration
			set = setEditHydration
		} else {
			show = editElectrolyte
			set = setEditElectrolyte
		}

		if (show) {
			return (
				<input
					type="number"
					className="form-control"
					defaultValue={data[name] || 0}
					min={0}
					max={500}
					onBlur={
						name === 'hydration' ? (
							(e) => updateValues('hydration', e.target.value)
						) : (
							(e) => updateValues('electrolyte', e.target.value)
						) }
				/>
			)
		}
		
		return (
			<h3 className={name === "hydration" ? "text-primary-dark" : "text-primary"}
			onClick={() => set(true)}>
				{data && data[name] ? data[name] : 0} oz
			</h3>
		)
	}

	return (
		<div className="card card-primary mb-4 p-4 border-0">
			<h4 className="text-primary-dark"> Hydration </h4>
			<div className="row journal-hydration">
				{hydrationData
					? hydrationData.map((item, index) => (
							<div className="col-6" key={index}>
								<div
									className={`card card-primary border-0 p-4 br-8 text-center filling-glass-outer ${
										item.name
									} ${change ? "animate" : ""} `}>
									<div className="d-flex justify-content-between mb-3">
										<h4> {item.name === "hydration" ? "Water(oz)" : "Electrolyte(oz)"} </h4>
										<section className="d-flex align-items-center">
											<h3
												className={
													item.name === "hydration"
														? "text-primary-dark pr-1 large"
														: "text-primary pr-1 large"
												}>
												{data && data[item.name] ? data[item.name] : 0} oz /
											</h3>
											<h4> {goal && goal[item.name] ? goal[item.name] : 0} oz </h4>
										</section>
									</div>
									<div className="d-flex justify-content-center align-items-center mb-5">
										<button
											disabled={!enable}
											className="btn"
											onClick={() => incrementHydrationValue(item, !isIncrement)}>
											-
										</button>
										<FillingGlass value={ goal[item.name] < data[item.name] ? 100 : (data[item.name] / goal[item.name]) * 100} />
										<button
											disabled={!enable}
											className="btn"
											onClick={() => incrementHydrationValue(item, isIncrement)}>
											+
										</button>
									</div>
									{editOptions(item.name)}
								</div>
							</div>
					  ))
					: null}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { journalUpdate, addNutritionJournal, getNutrionJournalEntries };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Hydration);
